var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeOffControlBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2964_235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8827 0.00588619V29.9985C15.2713 29.9985 14.6659 30.0059 14.0604 29.9985C13.9795 29.9985 13.8926 29.9071 13.8252 29.8408C10.7821 26.8511 7.74198 23.859 4.70488 20.8644C4.5903 20.7438 4.52333 20.587 4.51605 20.4221C4.50507 16.8182 4.50507 13.2142 4.51605 9.61031C4.52721 9.43392 4.60092 9.26697 4.72436 9.13856C7.74048 6.15871 10.7646 3.18573 13.7967 0.219638C13.9289 0.102741 14.0973 0.0331456 14.2747 0.0221002C14.7962 -0.0103322 15.3192 0.00588619 15.8827 0.00588619ZM14.534 1.40785C14.4516 1.47419 14.4111 1.50073 14.3841 1.53463C11.6078 4.26387 8.83344 6.99605 6.06109 9.73119C5.94745 9.86771 5.88736 10.0398 5.89175 10.2162C5.88126 13.4034 5.89174 16.5907 5.87975 19.7779C5.87453 19.8853 5.8933 19.9926 5.93472 20.0922C5.97614 20.1918 6.03921 20.2813 6.11952 20.3543C8.83093 23.0079 11.5384 25.6673 14.2418 28.3327C14.3257 28.4152 14.4156 28.4904 14.5415 28.6024L14.534 1.40785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.00181237 9.35229H3.80156V10.6658H1.36638V19.3282H3.80756V20.6388H-0.0078125L-0.00181237 9.35229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0117 9.36414L32.4698 20.6359",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8945 20.5194L32.5834 9.48059",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8945 20.5194L32.5834 9.48059",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2964_235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOffControlBar);
export default __webpack_public_path__ + "static/media/volumeOffControlBar.e4cc1328004cc06d7f2eea75452dc1df.svg";
export { ForwardRef as ReactComponent };